import axios from 'axios';

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

const external = {
  instance,
  get: ({ url, headers }) => instance.get(url, { headers }),
  post: ({ url, headers, data }) => instance.post(url, data, { headers }),
};

export default external;
